import { Flex, Link, Text } from "@simplybusiness/mobius";
import { Title } from "./Title";
import type { FooterLinks as FooterLinksType } from "./types";

export type FooterLinkProps = {
  links: FooterLinksType;
};

export const FooterLinks = (props: FooterLinkProps) => {
  const { links } = props;

  if (!links) {
    console.warn("Links will not render. Prop links is empty.");
    return null;
  }

  return (
    <div>
      <Title>Legal</Title>
      <Flex flexDirection="column">
        {links.map(({ href, text }) => (
          <Text variant="small" elementType="span" key={href}>
            <Link href={href} target="_blank">
              {text}
            </Link>
          </Text>
        ))}
      </Flex>
    </div>
  );
};
